import { render, staticRenderFns } from "./AddressChange.vue?vue&type=template&id=a7512cfc&scoped=true&"
import script from "./AddressChange.vue?vue&type=script&lang=js&"
export * from "./AddressChange.vue?vue&type=script&lang=js&"
import style0 from "./AddressChange.vue?vue&type=style&index=0&id=a7512cfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7512cfc",
  null
  
)

export default component.exports